import React, { Component } from 'react';

class Events extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var profilepic= "images/"+this.props.data.image;
      var bio = this.props.data.bio;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var resumeDownload = this.props.data.resumedownload;
    }

    return (
      <section id="about">
      
 <div class="container">
            <h4>Timeline Style : Demo-7</h4>
            <div class="row">
                <div class="col-md-12">
                    <div class="main-timeline7">
                        <div class="timeline">
                            <div class="timeline-icon"><i class="fa fa-globe"></i></div>
                            <span class="year">2018</span>
                            <div class="timeline-content">
                                <h5 class="title">Web Desginer</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum mattis felis vitae risus pulvinar tincidunt. Nam ac venenatis enim. Aenean hendrerit justo sed.
                                </p>
                            </div>
                        </div>
                        <div class="timeline">
                            <div class="timeline-icon"><i class="fa fa-rocket"></i></div>
                            <span class="year">2017</span>
                            <div class="timeline-content">
                                <h5 class="title">Web Developer</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum mattis felis vitae risus pulvinar tincidunt. Nam ac venenatis enim. Aenean hendrerit justo sed.
                                </p>
                            </div>
                        </div>
                        <div class="timeline">
                            <div class="timeline-icon"><i class="fa fa-briefcase"></i></div>
                            <span class="year">2016</span>
                            <div class="timeline-content">
                                <h5 class="title">Web Desginer</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum mattis felis vitae risus pulvinar tincidunt. Nam ac venenatis enim. Aenean hendrerit justo sed.
                                </p>
                            </div>
                        </div>
                        <div class="timeline">
                            <div class="timeline-icon"><i class="fa fa-mobile"></i></div>
                            <span class="year">2015</span>
                            <div class="timeline-content">
                                <h5 class="title">Web Developer</h5>
                                <p class="description">
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum mattis felis vitae risus pulvinar tincidunt. Nam ac venenatis enim. Aenean hendrerit justo sed.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

   </section>
    );
  }
}

export default Events;
